module.exports = __webpack_public_path__ + "05_veryshort_black.5c04df04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_veryshort_black.png
// module id = halq
// module chunks = 0